import { getOperatorOptions, getInclusionOptions } from '../logicHelpers'
import { countries } from '@dashboard/data/countries'

const locationSource = () => ({
  types: [
    { label: 'Country', value: 'country', description: 'Where they are, from their IP address' },
    { label: 'City', value: 'city', description: 'Their city, from their IP address' }
  ],
  inputs: [
    {
      control: 'select',
      key: 'country-operator-select',
      name: 'operator',
      options: getInclusionOptions(),
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'location' && condition.$type === 'country'
    },
    {
      control: 'multiselect',
      key: 'country-select',
      name: 'value',
      multiple: true,
      'open-on-focus': true,
      'clear-search-on-open': true,
      options: countries,
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'location' && condition.$type === 'country'
    },
    {
      control: 'select',
      key: 'city-operator-select',
      name: 'operator',
      options: getOperatorOptions(),
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'location' && condition.$type === 'city'
    },
    {
      control: 'text',
      key: 'city-value-input',
      name: 'value',
      placeholder: 'Enter city name',
      can: (condition: { $source: string; $type: string }) =>
        condition.$source === 'location' && condition.$type === 'city'
    }
  ]
})

export default locationSource
